"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array-buffer.constructor.js");
require("core-js/modules/es.array-buffer.slice.js");
require("core-js/modules/es.array-buffer.detached.js");
require("core-js/modules/es.array-buffer.transfer.js");
require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.typed-array.uint8-array.js");
require("core-js/modules/es.typed-array.at.js");
require("core-js/modules/es.typed-array.copy-within.js");
require("core-js/modules/es.typed-array.every.js");
require("core-js/modules/es.typed-array.fill.js");
require("core-js/modules/es.typed-array.filter.js");
require("core-js/modules/es.typed-array.find.js");
require("core-js/modules/es.typed-array.find-index.js");
require("core-js/modules/es.typed-array.find-last.js");
require("core-js/modules/es.typed-array.find-last-index.js");
require("core-js/modules/es.typed-array.for-each.js");
require("core-js/modules/es.typed-array.includes.js");
require("core-js/modules/es.typed-array.index-of.js");
require("core-js/modules/es.typed-array.iterator.js");
require("core-js/modules/es.typed-array.join.js");
require("core-js/modules/es.typed-array.last-index-of.js");
require("core-js/modules/es.typed-array.map.js");
require("core-js/modules/es.typed-array.reduce.js");
require("core-js/modules/es.typed-array.reduce-right.js");
require("core-js/modules/es.typed-array.reverse.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.slice.js");
require("core-js/modules/es.typed-array.some.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.typed-array.subarray.js");
require("core-js/modules/es.typed-array.to-locale-string.js");
require("core-js/modules/es.typed-array.to-reversed.js");
require("core-js/modules/es.typed-array.to-sorted.js");
require("core-js/modules/es.typed-array.to-string.js");
require("core-js/modules/es.typed-array.with.js");
require("core-js/modules/es.uint8-array.set-from-base64.js");
require("core-js/modules/es.uint8-array.set-from-hex.js");
require("core-js/modules/es.uint8-array.to-base64.js");
require("core-js/modules/es.uint8-array.to-hex.js");
require("core-js/modules/web.atob.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.dom-exception.constructor.js");
require("core-js/modules/web.dom-exception.stack.js");
require("core-js/modules/web.dom-exception.to-string-tag.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _auth = require("@/utils/auth");
var _cloud = require("@/utils/cloud");
var _request = _interopRequireDefault(require("@/utils/request"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'WlJmPrint',
  props: {
    // 业务单据编码
    billCode: {
      type: String,
      require: true,
      default: ''
    },
    // 模板查询参数
    printTemplateCondition: {
      type: [Object, Function],
      default: function _default() {
        return {};
      }
    },
    // 打印模板内从查询参数，在数据源页面配置的参数，比如：{"billCode":billCode,"pageSize":"100"}
    queryParam: {
      type: [Object, Function],
      require: false,
      default: function _default() {
        return {};
      }
    },
    // 打印类型
    // pdf-PDF打印，适合单条打印；browser-浏览器打印，支持多条数据打印
    model: {
      type: String,
      require: false,
      default: 'browser'
    },
    titleDesc: {
      type: String,
      default: '选择打印模板'
    },
    writePrintStatus: {
      type: Function,
      required: false,
      default: function _default() {
        return null;
      }
    },
    validate: {
      type: Function,
      require: false,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      openDialog: false,
      showDialog: false,
      jmReportId: '',
      // 积木设计报表ID
      printTemplateList: [],
      // 打印模板
      printLoading: false
    };
  },
  computed: {
    settings: function settings() {
      return require('@/settings.js');
    },
    label: function label() {
      return this.$attrs.label || '打印';
    },
    printTemplateRequire: function printTemplateRequire() {
      var _this = this;
      var key = Object.keys(this.settings).find(function (k) {
        return /^jm(-{0,1})template(-{0,1})url$/i.test(k);
      });
      var url = this.settings[key];
      var data = {};
      if (this.$$isNoEmpty(this.billCode)) Object.assign(data, {
        billCode: this.billCode
      });
      if (this.$$isNoEmpty(this.printTemplateCondition)) Object.assign(data, (0, _objectSpread2.default)({}, typeof this.printTemplateCondition === 'function' ? this.printTemplateCondition() : this.printTemplateCondition));
      if (url) return function () {
        return (0, _request.default)({
          url: url,
          data: data,
          method: 'post',
          baseURL: ''
        });
      };
      return function () {
        return new Promise(function (resolve, reject) {
          var msg = '无法获取积木模板列表的地址，请在 ./settings.js 文件中设置 jmTemplateUrl ';
          _this.$message.error(msg);
          reject(msg);
        });
      };
    },
    printUrl: function printUrl() {
      var key = Object.keys(this.settings).find(function (k) {
        return /^jm(-{0,1})print(-{0,1})url$/i.test(k);
      });
      var url = this.settings[key];
      if (url) return "".concat(url, "/jmreport/view/");else this.$message.error('无法获取积木打印的地址，请在 ./settings.js 文件中设置 jmPrintBrowserUrl ');
      return '';
    },
    printPdf: function printPdf() {
      var url = _cloud.urls.jmreport + '/jmreport/exportPdf';
      var data = (0, _objectSpread2.default)({
        excelConfigId: this.jmReportId
      }, this.queryParam);
      var headers = {
        token: (0, _auth.getToken)(),
        'Content-Type': 'application/json;charset=utf-8'
      };
      return function () {
        return (0, _request.default)({
          url: url,
          data: data,
          method: 'post',
          headers: headers,
          isJmReport: true
        });
      };
    }
  },
  methods: {
    /** 获取打印模板
     * @return { void }
     */
    getPrintTemplate: function getPrintTemplate() {
      var _this2 = this;
      // 查找菜单对应的打印模板
      if (!this.billCode && this.$$isEmpty(this.printTemplateCondition)) return this.$message.warning('积木报表打印 未设置 billCode 或 printTemplateCondition');else {
        return this.printTemplateRequire().then(function (res) {
          var _ref, _res$data;
          _this2.printTemplateList.length = 0;
          if (res.code === 200) _this2.printTemplateList = (_ref = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.rows) !== null && _ref !== void 0 ? _ref : [];
          if (_this2.printTemplateList.length === 1) _this2.jmReportId = _this2.printTemplateList[0].jmreportId;
          return res;
        });
      }
    },
    /** 打开打印模板选择
     * @return { void }
     */
    openPrintTemplate: function openPrintTemplate() {
      var _this3 = this;
      // 校验
      var validateMsg = this.validate();
      if (validateMsg) {
        this.$message.warning(validateMsg);
      } else {
        this.getPrintTemplate() // 获取打印模板
        .then(function (res) {
          if (res.code === 200) {
            _this3.openDialog = true;
          } else {
            _this3.$message.error('获取打印模板失败');
          }
        });
      }
    },
    /** 打印
     * @return { void }
     */
    onJmPrint: function onJmPrint() {
      this.printLoading = true;
      this.writePrintStatus();
      if (!this.jmReportId) return this.$message.warning('积木打印 无法获取积木打印 ID!！');
      if (this.model === 'pdf') this.pdfPrint();else if (this.model === 'browser') this.browserPrint();
      return true;
    },
    // pdf打印
    pdfPrint: function pdfPrint() {
      var _this4 = this;
      this.printPdf().then(function (res) {
        // console.log(res)
        // 成功
        if (res.success) {
          // 获取base64文件
          var file = res.result.file;
          var bstr = atob(file);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr], {
            type: 'application/pdf;chartset=UTF-8'
          });
          // 创建url
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        }
        // }).catch(function () {
      }).finally(function () {
        return setTimeout(function () {
          return _this4.openDialog = false;
        }, 500);
      });
    },
    // 浏览器打印
    browserPrint: function browserPrint() {
      if (!this.printUrl) return this.$message.warning('积木打印 无法获取积木地址！');
      // 遍历queryParam拼装成 key1=value1&key2=value2
      var queryJson = {};
      var queryStr = '';
      if (typeof this.queryParam === 'function') {
        queryJson = this.queryParam();
      } else {
        queryJson = this.queryParam;
      }
      for (var key in queryJson) {
        var qStr = key + '=' + queryJson[key];
        queryStr = queryStr + '&' + qStr;
      }
      var printUrlNew = "".concat(this.printUrl).concat(this.jmReportId, "?token=").concat((0, _auth.getToken)()) + queryStr;
      window.open(printUrlNew, '_blank');
      this.openDialog = false;
      return true;
    }
  },
  created: function created() {
    this.getPrintTemplate();
  }
};